export function nameEncodeMap() {
  return {
    single_space: "_",
    dot: "$",
    hyphen: "__"
  };
}

export function nameDecodeMap() {
  return {
    underscore: " ",
    dollar: ".",
    dUnderscore: "-"
  };
}
